import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import AppointmentService from '../utils/AppointmentService.js';
import "../CSS/Dashboard.css"
import CirclePlus from '../images/dbplus@3x.png'
import Modal from 'react-modal'
import MyGarageVehicle from './MyGarageVehicle.js';
import VehicleForm from './VehicleForm.js';
import URLService from '../utils/URLService.js';
import { ClipLoader } from 'react-spinners';


export default class MyGarage extends Component {
  constructor(props){
    super(props)
    this.state = {
      vehicles: [],
      vehiclesHTML: [],
      open:false
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.reloadGarage = this.reloadGarage.bind(this)
  }
  componentDidMount(){
    document.getElementById('background').addEventListener('scroll', this.handleScroll);
    this.Appt = new AppointmentService()

      this.Appt.vehicles()
      .then(res =>{
        if(res){
          var parentThis = this
          var vehiclesHTML = []
          if(res.vehicles){
            res.vehicles.forEach(function(vehicle){
              vehiclesHTML.push(<MyGarageVehicle reloadGarage={parentThis.reloadGarage} vehicle={vehicle} />)
            })
          }

          this.setState({
            vehicles: res.vehicles,
            vehiclesHTML: vehiclesHTML
          })
        }
        else {
          //throw new Error('Invalid response to getting ads' + res);
        }
      })
      .catch(err =>{
        //throw new Error('Error getting ads' + err.message);
      })
    this.watchID = navigator.geolocation.watchPosition((position) => {
      localStorage.setItem('lat', position.coords.latitude)
      localStorage.setItem('lng', position.coords.longitude)

    })
  }
  openModal() {
    this.setState({
      open: true,
    })
  }
  closeModal() {
    this.setState({
      open:false,
    })
  }
  reloadGarage(vehicle) {
    this.Appt.vehicles()
    .then(res =>{
      if(res){
        var parentThis = this
        var vehiclesHTML = []
        if(res.vehicles){
          res.vehicles.forEach(function(vehicle){
            vehiclesHTML.push(<MyGarageVehicle reloadGarage={parentThis.reloadGarage} vehicle={vehicle} />)
          })
        }

        this.setState({
          vehicles: res.vehicles,
          vehiclesHTML: vehiclesHTML
        })

      }
      else {
        //throw new Error('Invalid response to getting ads' + res);
      }
    })
    .catch(err =>{
      //throw new Error('Error getting ads' + err.message);
    })
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  };



  handleScroll = (event) => {
    var element = document.getElementById('background')
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {

    }
  };
  //doesn't work yet
  linkTo() {
    window.href = this.state.ad.url
  }
  render() {
    const modalStyle =
    this.state.width < 780 ?
    {
      content: {
        top                   : '22.5%',
        left                  : '0%',
        height                : '55%',
        width                 : '100%',
        padding               : '10px',
        right                 : 'auto',
        backgroundColor       : '#134270',
        color                 : 'white',
      }
    }:
      {
        content: {
          top                   : '22.5%',
          left                  : '30%',
          height                : '55%',
          width                 : '40%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : '#134270',
          color                 : 'white',
        }
      }
    return (
      <div>
        <h3 className="dashboardHeader">My Garage<img className="addIcon" src={CirclePlus} onClick={this.openModal}></img></h3>
          <ul className="appointmentsList">
              {this.state.vehiclesHTML}
          </ul>
          <Modal
            style={modalStyle}
            isOpen={this.state.open}
            contentLabel="Example Modal">
            <VehicleForm selectVehicle = {this.reloadGarage} closeModal={this.closeModal}/>
          </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/MyGarage.js